import { useMsal } from "@azure/msal-react";
import { useGoogleLogin } from "@react-oauth/google";
// import jsforce from "jsforce";
import { useState } from "react";
import config from "../../config/config.json";

export default function LoginSSO({ verifySsoToken, validatingOTP, provider, setProvider }) {
  const [processing, setProcessing] = useState(false);
  const [showSalesforceDropdown, setShowSalesforceDropdown] = useState(false);
  const [selectedSalesforceClient, setSelectedSalesforceClient] = useState("");
  const { instance } = useMsal();

  // Get Salesforce client options from config
  const salesforceClients = config.salesforce_clients || {};

  const handleGoogleSuccess = (res) => {
    verifySsoToken(res.access_token, provider);
    setProcessing(false);
  };

  const handleError = (err) => {
    setProcessing(false);
    setProvider("");
    verifySsoToken(null, null, err);
  };

  const handleGoogleLogin = (e) => {
    setProcessing(true);
    setProvider("GOOGLE");
    googleLogin(e);
  };

  const handleMicrosoftLogin = () => {
    setProcessing(true);
    setProvider("MS");
    instance
      .loginPopup()
      .then((res) => {
        verifySsoToken(res.idToken, "MS");
        setProcessing(false);
      })
      .catch((err) => {
        handleError(err);
      });
  };

  // const handleSalesforceLogin = () => {
  //   if (!selectedSalesforceClient) {
  //     return;
  //   }

  //   const clientConfig = salesforceClients[selectedSalesforceClient];
  //   if (!clientConfig) {
  //     return;
  //   }

  //   setProcessing(true);
  //   setProvider("SALESFORCE");

  //   // Salesforce OAuth 2.0 User-Agent Flow (implicit)
  //   const oauth2 = new jsforce.OAuth2({
  //     clientId: clientConfig.clientId,
  //     redirectUri: config.authWeb + "/callback/salesforce",
  //     loginUrl: clientConfig.domain
  //   });
  //   // Use 'openid' and 'id' scopes - 'id' returns user info including email via userinfo endpoint
  //   // Note: These scopes must be enabled in your Salesforce External Client App settings
  //   const authUrl = oauth2.getAuthorizationUrl({ scope: 'web', response_type: 'token' });

  //   // Open popup for Salesforce login
  //   const width = 500;
  //   const height = 600;
  //   const left = window.screenX + (window.outerWidth - width) / 2;
  //   const top = window.screenY + (window.outerHeight - height) / 2;
  //   const popup = window.open(
  //     authUrl,
  //     "SalesforceLogin",
  //     `width=${width},height=${height},left=${left},top=${top}`
  //   );

  //   // Listen for the callback
  //   const checkPopup = setInterval(() => {
  //     try {
  //       if (!popup || popup.closed) {
  //         clearInterval(checkPopup);
  //         setProcessing(false);
  //         setProvider("");
  //         setShowSalesforceDropdown(false);
  //         return;
  //       }

  //       // Check if we're on the callback URL
  //       if (popup.location.href.includes("/callback/salesforce")) {
  //         const hash = popup.location.hash;
  //         popup.close();
  //         clearInterval(checkPopup);

  //         // Parse the access token from the hash
  //         const params = new URLSearchParams(hash.substring(1));
  //         const accessToken = params.get("access_token");

  //         if (accessToken) {
  //           verifySsoToken(accessToken, "SALESFORCE");
  //         } else {
  //           handleError(new Error("No access token received from Salesforce"));
  //         }
  //         setProcessing(false);
  //         setShowSalesforceDropdown(false);
  //       }
  //     } catch (e) {
  //       // Cross-origin error - popup is on Salesforce domain, keep waiting
  //     }
  //   }, 500);
  // };

  const googleLogin = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: handleError,
    flow: "implicit"
  });

  const getGoogleSignInBtn = () => {
    if (config.blockGoogleLogin && (processing || validatingOTP) && provider !== "GOOGLE") {
      return null;
    }

    return (
      <button
        type="button"
        className="login-with-btn google-btn w-full"
        onClick={handleGoogleLogin}
        disabled={validatingOTP}
      >
        Sign in with Google
        {validatingOTP || processing ? (
          <span className="absolute right-0 text-sm mr-3">
            {validatingOTP || processing ? (
              <i className="fa-solid fa-circle-notch fa-spin text-sp-800"></i>
            ) : (
              <i className="fa-solid fa-check text-green-500"></i>
            )}
          </span>
        ) : null}
      </button>
    );
  };

  const getMicrosoftSignInBtn = () => {
    if (config.blockMSLogin && (processing || validatingOTP) && provider !== "MS") {
      return null;
    }

    return (
      <button
        type="button"
        className="mt-4 login-with-btn ms-btn w-full"
        onClick={handleMicrosoftLogin}
        disabled={validatingOTP}
      >
        Sign in with Microsoft
        {validatingOTP || processing ? (
          <span className="absolute right-0 text-sm mr-3">
            {validatingOTP || processing ? (
              <i className="fa-solid fa-circle-notch fa-spin text-sp-800"></i>
            ) : (
              <i className="fa-solid fa-check text-green-500"></i>
            )}
          </span>
        ) : null}
      </button>
    );
  };

  // const handleSalesforceButtonClick = () => {
  //   setShowSalesforceDropdown((prev) => !prev);
  // };

  // const handleSelectSalesforceClient = (clientName) => {
  //   setSelectedSalesforceClient(clientName);
  //   setShowSalesforceDropdown(false);
  //   // Trigger login after a small delay to allow state to update
  //   setTimeout(() => {
  //     const clientConfig = salesforceClients[clientName];
  //     if (!clientConfig) return;

  //     setProcessing(true);
  //     setProvider("SALESFORCE");

  //     const oauth2 = new jsforce.OAuth2({
  //       clientId: clientConfig.clientId,
  //       redirectUri: config.authWeb + "/callback/salesforce",
  //       loginUrl: clientConfig.domain
  //     });
  //     const authUrl = oauth2.getAuthorizationUrl({ scope: 'web', response_type: 'token' });

  //     const width = 500;
  //     const height = 600;
  //     const left = window.screenX + (window.outerWidth - width) / 2;
  //     const top = window.screenY + (window.outerHeight - height) / 2;
  //     console.log(authUrl);
  //     const popup = window.open(
  //       authUrl,
  //       "SalesforceLogin",
  //       `width=${width},height=${height},left=${left},top=${top}`
  //     );

  //     // Handler for receiving the token from the popup
  //     const handleMessage = (event) => {
  //       if (event.data && event.data.type === 'SALESFORCE_LOGIN') {
  //         const { accessToken, instanceUrl } = event.data;
  //         console.log(event);
  //         if (accessToken) {
  //           verifySsoToken(accessToken, "SALESFORCE", null, { domain: instanceUrl });
  //         } else {
  //           handleError(new Error("No access token received from Salesforce"));
  //         }

  //         // Cleanup
  //         window.removeEventListener('message', handleMessage);
  //         if (checkPopup) clearInterval(checkPopup);
  //         if (popup && !popup.closed) popup.close();

  //         setProcessing(false);
  //         setShowSalesforceDropdown(false);
  //       }
  //     };

  //     // Listen for the message
  //     window.addEventListener('message', handleMessage);

  //     const checkPopup = setInterval(() => {
  //       if (!popup || popup.closed) {
  //         clearInterval(checkPopup);
  //         window.removeEventListener('message', handleMessage); // Clean up listener if closed manually
  //         setProcessing(false);
  //         setProvider("");
  //         return;
  //       }
  //     }, 500);
  //   }, 0);
  // };

  // const getSalesforceSignInBtn = () => {
  //   // Completely hide Salesforce button if blocked in config or no clients configured
  //   const clientKeys = Object.keys(salesforceClients);
  //   if (config.blockSalesforceLogin || clientKeys.length === 0) {
  //     return null;
  //   }

  //   return (
  //     <div className="relative mt-4">
  //       <button
  //         type="button"
  //         className="login-with-btn salesforce-btn w-full"
  //         onClick={handleSalesforceButtonClick}
  //         disabled={validatingOTP || processing}
  //       >
  //         Sign in with Salesforce
  //         <span className="absolute right-0 mr-3">
  //           {(validatingOTP || processing) && provider === "SALESFORCE" ? (
  //             <i className="fa-solid fa-circle-notch fa-spin text-sp-800"></i>
  //           ) : (
  //             <i className={`fa-solid fa-chevron-${showSalesforceDropdown ? 'up' : 'down'} text-gray-500`}></i>
  //           )}
  //         </span>
  //       </button>
  //       {showSalesforceDropdown && (
  //         <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
  //           {clientKeys.map((clientName) => (
  //             <button
  //               key={clientName}
  //               type="button"
  //               className="w-full px-4 py-3 text-left text-gray-700 hover:bg-gray-100 first:rounded-t-md last:rounded-b-md transition-colors"
  //               onClick={() => handleSelectSalesforceClient(clientName)}
  //               disabled={validatingOTP || processing}
  //             >
  //               {clientName}
  //             </button>
  //           ))}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  return (
    <div className="relative w-full py-3">
      {getGoogleSignInBtn()}
      {getMicrosoftSignInBtn()}
      {/* getSalesforceSignInBtn() */}
    </div>
  );
}
